import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon/Icon';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import styled from 'styled-components';

interface IBtnLoading {
  loading: boolean;
  fullWidth?: boolean;
  type?: any;
  disabled?: boolean;
  children?: any;
  onClick?: () => void;
  customColor?: boolean;
  fontColor?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
}
export const BtnLoading = (props: IBtnLoading) => (
  <Button
    variant="contained"
    color="primary"
    type={props.type || 'button'}
    style={{
      backgroundColor: props.disabled
        ? '#cdcdcd'
        : props.customColor
        ? props.backgroundColor
        : '#083350',
      color: props.customColor ? props.fontColor : '',
      width: props.fullWidth ? '100%' : '220px',
      minHeight: '42px',
      borderRadius: '24px',
      ...props.style
    }}
    fullWidth={props.fullWidth}
    disabled={props.disabled}
    onClick={() => props.onClick && props.onClick()}
  >
    {props.loading ? (
      <CircularProgress variant="indeterminate" color="inherit" />
    ) : (
      props.children
    )}
  </Button>
);

interface IMsgbox {
  error?: string;
  warning?: string;
  success?: string;
  duration?: number;
  onClose: () => void;
}
export const Msgbox = (props: IMsgbox) => (
  <Snackbar
    open={!!props.error || !!props.warning || !!props.success}
    autoHideDuration={props.duration}
    onClose={() => props.onClose()}
  >
    <Alert
      severity={
        props.error
          ? 'error'
          : props.warning
          ? 'warning'
          : props.success
          ? 'success'
          : 'info'
      }
      elevation={6}
      variant="filled"
      action={
        <Button
          color="inherit"
          style={{ minHeight: 40 }}
          onClick={() => props.onClose()}
        >
          <Icon>close</Icon>
        </Button>
      }
    >
      {props.error || props.warning || props.success}
    </Alert>
  </Snackbar>
);

interface ILoading {
  open: boolean;
  color?: any;
  hasBackdrop?: boolean;
  theme?: any;
  children?: any;
}
const LoadingText = styled.span`
  margin-left: 1rem;
  ${({ theme, color }) => `
    color: ${
      color ? theme.palette[color]?.main : theme.palette.primary.contrastText
    };
    font-weight: 600;
  `}
`;
export const Loading = (props: ILoading) => (
  <Backdrop open={props.open} invisible={!props.hasBackdrop}>
    <CircularProgress color={props.color || 'inherit'} />
    <LoadingText color={props.color}>{props.children}</LoadingText>
  </Backdrop>
);

interface IOptional {
  valid: boolean;
  children?: any;
}
export const Optional = (props: IOptional) =>
  props.valid ? props.children : null;
